import { TernBrand } from "@/components/brands/TernBrand";

// The browser return is not payment evidence. Keep this public page neutral;
// only Tern's signed events can confirm money on the landlord's ledger.
export default function TernReturnPage() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-bg-dark px-4 py-10">
      <img
        src="/logo-variant-a.png"
        alt="Rentinit"
        className="mb-8 h-7 w-auto"
      />
      <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-[var(--shadow-depth-md)] ring-1 ring-gray-300/60">
        <TernBrand large className="mb-5" />
        <h1 className="text-xl font-semibold text-gray-900">
          You can close this page
        </h1>
        <p className="mt-3 text-sm text-muted-foreground">
          Your landlord or manager can check confirmed payments in Rentinit.
        </p>
        <p className="mt-4 text-sm text-muted-foreground">
          If the payment page showed an error, contact your landlord or manager
          before trying again.
        </p>
      </div>
    </main>
  );
}
